import React from 'react';
import { connect } from 'react-redux';

import CategoryInfo from './infoComponents/categoryInfo';
import LevelInfo from './infoComponents/levelInfo';
import ZoneInfo from './infoComponents/zoneInfo';
import SheetInfo from './infoComponents/sheetInfo';
import StretchInfo from './infoComponents/stretchInfo';
import AppartmentInfo from './infoComponents/appartmentInfo';
import StartInfo from './infoComponents/startInfo';
import EndInfo from './infoComponents/endInfo';
import CustomcardfieldInfo from './infoComponents/customcardfieldInfo';
import StartDateInfo from './infoComponents/startDateInfo';
import FinishDateInfo from './infoComponents/finishDateInfo';
import SignaturesInfo from './infoComponents/signaturesInfo';
import CloseButton from './closeButton.js'
import { _ } from '../../functions/translator';
import { findProtocolGroup } from '../../functions/finder.js';
import CloseInfo from './infoComponents/closeInfo.js';


class CardsGroupInfo extends React.Component{

    render(){
        let customcardId = this.props.cardsGroup.attributes.customcard_id;
        let customcard = null;
        const customcardfieldComponents = [];
        if (customcardId) {
            customcard = this.props.projectData.customcards[customcardId.toString()]
            for (const customcardfieldData of Object.values(customcard.customcardfields)) {
                if (customcardfieldData.attributes.reference_field !== 'description') {
                    customcardfieldComponents.push(
                        <CustomcardfieldInfo cardsGroup={this.props.cardsGroup} customcardfield={customcardfieldData}/>
                    ); 
                }
            }
        }
        let protocolId = this.props.cardsGroup.attributes.protocol_id;
        let protocolgroup = null;
        if (protocolId) {
            protocolgroup = findProtocolGroup(protocolId, this.props.projectData.protocolgroups);
        }
        let protocol = protocolgroup ? protocolgroup.protocols[protocolId.toString()] : null;
        let protocolName = protocol ? ' - ' + protocol.attributes.name : '';
        let protocolGroupName = protocolgroup ? protocolgroup.attributes.name + protocolName : _('Ninguno');

        return (
            <div className='general-info-layout'>
                <CloseButton/>
                <h4>
                    {_('Datos Generales')}
                    <span className='text-secondary-old h5 font-weight-normal'>
                        {' - ' + _('Protocolo') + ' N° ' + this.props.cardsGroup.attributes.index + ': ' + protocolGroupName}
                    </span>
                </h4>
                <div className='general-info-container'>
                    <StartDateInfo cardsGroupData={this.props.cardsGroup}/>
                    <FinishDateInfo cardsGroupData={this.props.cardsGroup}/>
                    <LevelInfo 
                        cardsGroup={this.props.cardsGroup}
                        levels={this.props.projectData.levels}
                        customcard={customcard}/>
                    <ZoneInfo 
                        cardsGroup={this.props.cardsGroup}
                        customcard={customcard}/>
                    <SheetInfo 
                        cardsGroup={this.props.cardsGroup}
                        customcard={customcard}/>
                    <StretchInfo 
                        cardsGroup={this.props.cardsGroup}
                        customcard={customcard}/>
                    <AppartmentInfo
                        appartments={this.props.projectData.appartments}
                        cardsGroup={this.props.cardsGroup}
                        customcard={customcard}/>
                    <StartInfo 
                        cardsGroup={this.props.cardsGroup}
                        customcard={customcard}/>
                    <EndInfo 
                        cardsGroup={this.props.cardsGroup}
                        customcard={customcard}/>
                    {customcardfieldComponents}
                    <CategoryInfo 
                        cardsGroup={this.props.cardsGroup}
                        categories={this.props.projectData.card_categories}
                        customcard={customcard}/>
                    <SignaturesInfo 
                        cardsGroup={this.props.cardsGroup}  
                        usersData={this.props.projectUsers}/>
                    <CloseInfo 
                        cardsGroup={this.props.cardsGroup} 
                        usersData={this.props.projectUsers}/>
                </div>
            </div> 
        );

    }
}

function mapStateToProps( state ){
    return {
        popup : state.popup,
        projectData : state.projectData,
        projectUsers : state.projectUsers,
    }
}

export default connect(mapStateToProps)(CardsGroupInfo);